import PostsAdapter from './base';

export default class Tag extends PostsAdapter {
  modelNamePlural = 'tags';
}
